import React, { useState, useEffect, useRef } from 'react';
import { Map, TileLayer, Marker, Popup, withLeaflet } from 'react-leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import L from 'leaflet';

// Importação obrigatória dos estilos
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';

// Correção para os ícones do Leaflet que somem no React
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

// Sub-componente interno para gerenciar a busca
const SearchControl = withLeaflet((props) => {
  useEffect(() => {
    const { map } = props.leaflet;
    const provider = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider: provider,
      style: 'bar',
      showMarker: false, // Desativamos o marcador padrão da busca para usar o nosso do estado
      autoClose: true,
      retainZoomLevel: false,
    });

    map.addControl(searchControl);

    map.on('geosearch/showlocation', (e) => {
      const { x, y } = e.location; // x = Longitude, y = Latitude
      props.onLocationSelect(y, x); // passa (latitude, longitude) na ordem correta
    });

    return () => map.removeControl(searchControl);
  }, [props.leaflet]);

  return null;
});

function MapPicker({ onLocationSelect, isOpen, latitude, longitude }) {
  const [position, setPosition] = useState(
    latitude != null ? [latitude, longitude] : [-23.5505, -46.6333]
  );
  const mapRef = useRef(null);

  // Sincroniza posição quando trecho diferente é aberto ou form é limpo
  useEffect(() => {
    if (latitude != null && longitude != null) {
      setPosition(prev =>
        prev[0] === latitude && prev[1] === longitude ? prev : [latitude, longitude]
      );
    }
  }, [latitude, longitude]);

  // CORREÇÃO PARA O MAPA CINZA NO MODAL
  useEffect(() => {
    if (isOpen && mapRef.current) {
      // Pequeno atraso para o Modal terminar de animar
      setTimeout(() => {
        const map = mapRef.current.leafletElement;
        map.invalidateSize();
      }, 400);
    }
  }, [isOpen]);

  const handleLocationUpdate = (lat, lng) => {
    setPosition([lat, lng]);
    onLocationSelect(lat, lng);
  };

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <Map 
        ref={mapRef}
        center={position} 
        zoom={12} 
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                
        <SearchControl onLocationSelect={handleLocationUpdate} />

        <Marker position={position}>
          <Popup>Local selecionado</Popup>
        </Marker>
      </Map>
    </div>
  );
}

export default MapPicker;